import { NgModule } from '@angular/core';
import { ActivatedRouteSnapshot, PreloadAllModules, RouterModule, RouterStateSnapshot, Routes } from '@angular/router';
import { AuthDeactivateGuard } from './modules/core/services/auth-deactivate-guard.service';
// import { DemoComponent } from './modules/shared/demo/demo.component';

const routes: Routes = [
    {
        path: '',
        loadChildren: () =>
            import('./modules/e-met/e-met.module').then((m) => m.EMetModule),
    },
    {
        path: 'myphoto',
        loadChildren: () =>
            import('./modules/my-photo/my-photo.module').then(
                (m) => m.MyPhotoModule
            ),
    },
    {
        path: 'reference',
        loadChildren: () =>
            import('./modules/govgr-bootstrap/govgr-bootstrap.module').then(
                (m) => m.GovgrBootstrapModule
            ),
    },
    // {
    //     path: 'demo',
    //     component: DemoComponent,
    // },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
    ],
    exports: [RouterModule],
    providers: [AuthDeactivateGuard,
      {
        provide: 'externalUrlRedirectResolver',
        useValue: (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) =>
        {
          window.location.href = (route.data as any).externalUrl;
        }
      }],
})
export class AppRoutingModule {}
